<template>
    <layout-main>
        <head-title value="Delete Account" />
        <layout-content>
            <content-header>
                <top-nav>
                    <top-nav-back />
                    <top-nav-title>
                        Delete Account
                    </top-nav-title>
                </top-nav>
            </content-header>

            <content-body>
                <div class="p-4 flex flex-col gap-2">
                    <h2 class="text-xl">Steps to Request Account Deletion on Corperland</h2>
                    <p>To request the deletion of your account, please follow these steps:</p>
                    <ol class="ml-5 list-decimal">
                        <li class="list-item">Open the <strong>Corperland</strong> app.</li>
                        <li class="list-item">Navigate to the <strong>Settings</strong> menu.</li>
                        <li class="list-item">Select <strong>Account</strong> and then <strong>Delete Account</strong>.</li>
                        <li class="list-item">Follow the on-screen instructions to confirm your request.</li>
                    </ol>

                    <h2 class="text-xl mt-4">Data Deletion and Retention</h2>
                    <p>When you request to delete your account, the following data will be deleted:</p>
                    <ul class="ml-5 list-disc">
                        <li class="list-item">Personal information (e.g., name, email address)</li>
                        <li class="list-item">Profile information (e.g., bio, profile picture)</li>
                        <li class="list-item">Posts, comments, and likes</li>
                        <li class="list-item">Messages and chat history</li>
                        <li class="list-item">Account settings and preferences</li>
                    </ul>
                </div>
            </content-body>
        </layout-content>
    </layout-main>
</template>
